import React from "react"
import { createTheme, ThemeProvider } from "@mui/material"

export default function MuiThemeProvider({ children }: { children: React.ReactNode }) {
  const theme = createTheme({
    palette: {
      secondary: {
        main: "#00c298",
      },
    },
  })

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
